import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import EditPlanGroupApi from "../../../api/EditPlanGroupApi";
import { GetActiveScalesApi } from "../../../api/GetActiveScalesApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";

const { Option } = Select;

const { TextArea } = Input;

function EditPlanGroupModal(props) {
  const [submit, setSubmit] = useState(false);
  const [scales, setScales] = useState();
  const [form] = Form.useForm();
  const [valuesChanged, setValuesChanged] = useState(false);

  function handleCancel() {
    setSubmit(false);
    setScales();
    props.handleCancel();
    setValuesChanged(false);
    form.resetFields();
  }

  useEffect(() => {
    if (props.visible) {
      getScales();
    }
  }, [props.visible]);

  async function onFinish(value) {
    setSubmit(true);
    const apiResponse = await EditPlanGroupApi(
      props.planGroup.id,
      value.name,
      value.description,
      value.scale
    );
    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message === "success") {
      openNotificationSuccess("bottomRight", "Plan group edited successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't edit plan group. Try again later."
      );
    }
    handleCancel();
  }

  async function getScales() {
    const apiResponse = await GetActiveScalesApi();
    if (apiResponse.success) {
      setScales(apiResponse.data);
      form.setFields([
        {
          name: "scale",
          value: props.planGroup?.scale?.id,
        },
      ]);
    }
  }

  return (
    <Modal
      title="Edit plan group"
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="planGroup"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        form={form}
        initialValues={{
          name: props.planGroup?.name,
          description: props.planGroup?.description,
        }}
        onValuesChange={() => {
          setValuesChanged(true);
        }}
      >
        <Form.Item label="Group name*" name="name">
          <Input defaultValue={props.planGroup?.name} placeholder="name" />
        </Form.Item>

        <Form.Item label="Description" name="description">
          <TextArea
            defaultValue={props.planGroup?.description}
            showCount
            maxLength={100}
            placeholder="Description"
          />
        </Form.Item>

        <Form.Item label="Default scale" name="scale">
          <Select
            showSearch
            placeholder="Select designation"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {scales?.map((scale) => {
              return (
                <Option key={scale.id} value={scale.id}>
                  {scale.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit || !valuesChanged}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default EditPlanGroupModal;
